import axios from "axios";

const uploadFileToFakeURL = async (file: File) => {
  // ローカル開発用のフェイクアップロード処理
  return new Promise<boolean>((resolve) => {
    console.log(`Fake uploading ${file.name} to a fake URL...`);
    setTimeout(() => {
      console.log(`Fake upload complete for ${file.name}`);
      resolve(false); // 成功時に true を返す
    }, 1000); // 1秒待つ
  });
};

const uploadFileToRealURL = async (file: File, presignedUrl: string) => {
  try {
    const response = axios.put(presignedUrl, file, {
      headers: {
        "Content-Type": file.type,
      },
    });
    return response;
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};

const uploadFileByPresignedURL = async (file: File, presignedUrl: string) => {
  const isProduction = import.meta.env.PROD;
  if (!isProduction) {
    return uploadFileToFakeURL(file);
  } else {
    return uploadFileToRealURL(file, presignedUrl);
  }
};

export default uploadFileByPresignedURL;
